/**
 * AVSBlurBadge — iter173b · einheitliches "18+"-Symbol-Overlay für alle
 * Stellen wo Content vollflächig oder per-Region wegen fehlender AVS-Verifizierung
 * geblurrt wird. Dient sowohl der User-Wahrnehmung ("warum ist das unscharf?")
 * als auch der visuellen Konsistenz über Feed, STX-Grid und STX-Detail.
 *
 * Nutzung:
 *   <div className="relative">
 *     <img className="blur-2xl ..." src="..." />
 *     <AVSBlurBadge />
 *   </div>
 *
 * Der Container-Wrapper muss `position: relative` haben.
 */
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

export default function AVSBlurBadge({
  size = "md",
  testId = "avs-blur-badge",
  className = "",
}) {
  const { t } = useTranslation();
  const dims = {
    sm: { box: "w-12 h-12", num: "text-[11px]", plus: "text-[10px]" },
    md: { box: "w-20 h-20", num: "text-lg", plus: "text-sm" },
    lg: { box: "w-28 h-28", num: "text-2xl", plus: "text-xl" },
  }[size] || { box: "w-20 h-20", num: "text-lg", plus: "text-sm" };

  return (
    <div
      data-testid={testId}
      aria-label={t("media.avs_badge_aria")}
      className={`pointer-events-none absolute inset-0 flex items-center justify-center z-10 ${className}`}
    >
      <div
        className={`relative ${dims.box} rounded-full border-[3px] border-white/95 bg-black/25 backdrop-blur-sm flex items-center justify-center shadow-lg`}
      >
        <span className={`${dims.num} font-black text-white tracking-tight leading-none`}>18</span>
        <span
          className={`absolute -top-1 -right-1 ${dims.plus} font-black text-white leading-none`}
        >
          +
        </span>
      </div>
    </div>
  );
}

AVSBlurBadge.propTypes = {
  size: PropTypes.oneOf(["sm", "md", "lg"]),
  testId: PropTypes.string,
  className: PropTypes.string,
};
